import { TextField } from "@material-ui/core";
import React from "react";
import useFilterValue from "../Provider/hooks/useFilterValue";
import { FieldProductArticleFC } from "./types";

const FieldProductArticle: FieldProductArticleFC = () => {
  const { value, update } = useFilterValue("productArticle");
  const handlerChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    update(value);
  };
  return (
    <TextField
      size={"small"}
      fullWidth
      value={value}
      onChange={handlerChange}
      label={"Артикул товара"}
    />
  );
};

export default FieldProductArticle;
